var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.66406V3.33073H2.66667V24.6641H21.3333V8.66406H16ZM0 1.98646C0 1.25613 0.596653 0.664062 1.33133 0.664062H17.3333L23.9996 7.33073L24 25.9874C24 26.7293 23.4068 27.3307 22.6755 27.3307H1.32453C0.593013 27.3307 0 26.7237 0 26.0083V1.98646ZM10.6667 10.6641C10.6667 11.7686 9.7712 12.6641 8.66667 12.6641C7.56209 12.6641 6.66667 11.7686 6.66667 10.6641C6.66667 9.55949 7.56209 8.66406 8.66667 8.66406C9.7712 8.66406 10.6667 9.55949 10.6667 10.6641ZM19.3333 20.6641L14 11.3307L6.66667 20.6641H19.3333Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploading);
export default __webpack_public_path__ + "static/media/file-uploading.c8bd7805ea2f0f3a8b41472c02f4be2e.svg";
export { ForwardRef as ReactComponent };